import React, { useState } from 'react';
import { Form, Row } from 'reactstrap';
import { CustomForm } from 'components/Generic/CustomForm';
import { useForm } from 'react-hook-form';
import { Text } from 'components/Form/Fields';
import { STATES_BRAZIL } from 'utility/data-offiline';
import { SelectWihoutControl } from 'components/Form/Fields';
import { TableVisitRecord } from './table-visit-client';

const toRedirect = '/admin/client/';

export const FormClient = () => {
  const { reset, getValues, control, setValue } = useForm({
    defaultValues: {
      id: null,
      name: '',
      federalRegister: '',
      commission: 0,
      street: '',
      city: '',
      state: '',
      district: '',
      reference: '',
      phoneNumber: '',
      phoneNumber2: '',
      phoneNumber3: '',
      email: '',
    },
  });

  const [stateSelect, setStateSelect] = useState();

  const handleChangeData = (e) => {
    const currentState = e.target.value;
    setStateSelect(currentState);
    setValue('state', currentState);
  };

  // const columns = useMemo(
  //   () => [
  //     {
  //       Header: 'Produto',
  //       accessor: 'name',
  //     },
  //     {
  //       Header: 'Quantidade',
  //       accessor: 'quantity',
  //     },
  //     {
  //       Header: 'Vendido',
  //       accessor: 'sold',
  //     },
  //     {
  //       Header: 'Valor Pago',
  //       accessor: 'amount_paid',
  //     },
  //     {
  //       Header: 'Valor Devedor',
  //       accessor: 'debtor',
  //     },
  //     {
  //       Header: 'Devolução',
  //       accessor: 'returned',
  //     },
  //     {
  //       Header: 'Última Atualização',
  //       accessor: 'lastUpdate',
  //       Cell: ({ cell: { value } }) => (
  //         <span>{`${showDateFormated(value)}`}</span>
  //       ),
  //     },
  //   ],
  //   []
  // );

  return (
    <>
      <CustomForm
        nameForm={'Cadastro de Cliente'}
        typeForm={'POST'}
        pathUrl={'/v1/client'}
        toRedirect={toRedirect}
        getValues={getValues}
        loadValues={reset}
        forceRefreshPage
      >
        <Form>
          <div className='pl-lg-4'>
            <Row>
              <Text
                control={control}
                label={'Razão Social'}
                fieldName={'name'}
                placeholder={'Informe a razão social'}
                size={3}
              />
              <Text
                control={control}
                fieldName={'federalRegister'}
                label={'CPF/CNPJ'}
                placeholder={'Informe o documento'}
                size={3}
              />
              <Text
                control={control}
                fieldName={'commission'}
                label={'Comissão'}
                placeholder={'Informe a comissão do cliente'}
                size={3}
              />
            </Row>
            <Row>
              <Text
                control={control}
                label={'Rua'}
                placeholder={''}
                size={3}
                fieldName={'street'}
              />
              <SelectWihoutControl
                label={'Estado'}
                size={2}
                data={STATES_BRAZIL}
                onChange={handleChangeData}
                value={stateSelect}
              />
              <Text
                control={control}
                label={'Cidade'}
                placeholder={''}
                fieldName={'city'}
                size={2}
              />
              <Text
                control={control}
                label={'Bairro'}
                placeholder={''}
                fieldName={'district'}
                size={2}
              />
              <Text
                control={control}
                label={'Referencia'}
                placeholder={''}
                fieldName={'reference'}
                size={3}
              />
            </Row>
            <Row>
              <Text
                control={control}
                label={'E-mail'}
                placeholder={''}
                fieldName={'email'}
                size={3}
              />
              <Text
                control={control}
                label={'Telefone'}
                fieldName={'phoneNumber'}
                placeholder={''}
                size={3}
              />
              <Text
                control={control}
                label={'Telefone 2'}
                fieldName={'phoneNumber2'}
                placeholder={''}
                size={3}
              />
              <Text
                control={control}
                label={'Telefone 3'}
                fieldName={'phoneNumber3'}
                placeholder={''}
                size={3}
              />
            </Row>

            {getValues()?.id === null ? null : (
              <>
                <Row>
                  <div style={{ marginTop: '24px' }}>
                    <h3 style={{ marginTop: '20px' }}>Histórico</h3>
                    {getValues()?.id && (
                      <TableVisitRecord id={getValues()?.id} />
                    )}
                  </div>
                </Row>
              </>
            )}
          </div>
        </Form>
      </CustomForm>
    </>
  );
};
